module.exports = __webpack_public_path__ + "img/electronic-farm.485ca3f0.svg";